export default "__VITE_ASSET__Bon6htWy__"